import React from 'react'
import { Table, Spinner } from 'react-bootstrap'
import '../SanctionScreening/SearchResultsTable.css'

type sanctionScreeningCompany = {
  businessName?: string
  country?: string
  enquiryID?: string
  enquiryResultID?: string
}

type Props = {
  sanctionScreeningCompanies: sanctionScreeningCompany[]
  setSanctionScreeningCompany: (company: sanctionScreeningCompany) => void
}

const TableDataWorldCompliance: React.FC<Props> = ({
  sanctionScreeningCompanies,
  setSanctionScreeningCompany,
}) => (
  <div className="kyc-sanction-results-table-container">
    <table>
      <thead>
        <tr>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Company
          </td>
        </tr>
      </thead>
      <tbody>
        {sanctionScreeningCompanies.map((sanctionScreeningCompany, index) => (
          <tr
            key={sanctionScreeningCompany.enquiryID || index}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setSanctionScreeningCompany(sanctionScreeningCompany)
            }}
          >
            <td>{sanctionScreeningCompany.businessName}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default TableDataWorldCompliance
